import React from "react";
import { Label } from "../../ui/label";
import { Input } from "../../ui/input";

interface TestSetNameProps {
  name?: string;
  description?: string;
  onChange: (name: string, description: string) => void;
}

const TestSetName: React.FC<TestSetNameProps> = ({
  name,
  description,
  onChange,
}) => {
  return (
    <div className="space-y-8">
      {/* Section Header */}
      <div className="space-y-2">
        <h3 className="text-xl font-gc-med text-foreground">Test Set Details</h3>
        <p className="text-sm text-muted-foreground">
          Enter a name and description for your test set
        </p>
      </div>

      {/* Form Fields */}
      <div className="max-w-2xl space-y-6">
        <div className="space-y-3">
          <Label className="text-sm font-gc-med text-foreground">
            Name <span className="text-red-500">*</span>
          </Label>
          <Input
            value={name || ""}
            onChange={(e) => onChange(e.target.value, description || "")}
            placeholder="Enter test set name"
            className="w-full"
          />
          <p className="text-xs text-muted-foreground">
            A unique name for your test set
          </p>
        </div>

        <div className="space-y-3">
          <Label className="text-sm font-gc-med text-foreground">Description</Label>
          <textarea
            value={description || ""}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(name || "", e.target.value)}
            placeholder="Enter test set description"
            rows={4}
            className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none"
          />
          <p className="text-xs text-muted-foreground">
            Provide a brief description of this test set
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestSetName;
